module.exports = __webpack_public_path__ + "img/pic_card1@2x.5d1b967f.png";